import styled from 'styled-components';

export const Question = styled.div`
  border-radius: 5px;
  padding: 4px;
  background-color: #0000A0;
  color: white;
  display: flex;
  align-items: center;
  min-height: 50px;
  margin-bottom: 10px;
`;